






import Vue from 'vue';

export default Vue.extend({
  props: {
    progress: {
      type: Number,
      default: 0,
    },
  },
});
